import script from "./personnel.vue?vue&type=script&setup=true&lang=js"
export * from "./personnel.vue?vue&type=script&setup=true&lang=js"

import "./personnel.vue?vue&type=style&index=0&id=83a14b1c&lang=scss&scoped=true"

import exportComponent from "E:\\xm\\siggraph\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83a14b1c"]])

export default __exports__